import { getTextFromMenuNumberAndMenuValue } from '@/cruds/language.crud';
import { DOCUMENT_DELIVERY_STATUS } from '@/shared/constants';

export const textStatus = async (validated) => {
	let value = null;

	await new Promise((resolve, reject) => {
		setTimeout(() => {
			resolve(getTextFromMenuNumberAndMenuValue(1008, validated));
			reject(false);
		}, 100);
	}).then((data) => {
		value = data;
	});

	return value;
};

export const classStatus = (validated) => {
	let value = 'not-submitted';

	if (validated === 1) {
		value = 'info';
	} else if (validated === 2) {
		value = 'pending';
	} else if (validated === 8) {
		value = 'validated';
	} else if (validated === 4 || validated === 16) {
		value = 'refused';
	}

	return value;
};

export const classDocumentStatus = (validated) => {
	let value = 'not-submitted';

	if (validated === DOCUMENT_DELIVERY_STATUS.NOT_RECEIVED || validated === DOCUMENT_DELIVERY_STATUS.REFUSED) {
		value = 'refused';
	} else if (validated === DOCUMENT_DELIVERY_STATUS.RECEIVED) {
		value = 'pending';
	} else if (validated === DOCUMENT_DELIVERY_STATUS.READ) {
		value = 'info';
	} else if (validated === DOCUMENT_DELIVERY_STATUS.SIGNED || validated === DOCUMENT_DELIVERY_STATUS.VALIDATED) {
		value = 'validated';
	} else if (validated === DOCUMENT_DELIVERY_STATUS.SENT) {
		value = 'sent';
	}

	return value;
};

export const classUserDocumentStatus = (validated) => {
	let value = 'not-submitted';

	if (validated === DOCUMENT_DELIVERY_STATUS.NOT_RECEIVED || validated === DOCUMENT_DELIVERY_STATUS.REFUSED) {
		value = 'refused';
	} else if (validated === DOCUMENT_DELIVERY_STATUS.RECEIVED || validated === DOCUMENT_DELIVERY_STATUS.READ) {
		value = 'info';
	} else if (validated === DOCUMENT_DELIVERY_STATUS.SIGNED) {
		value = 'pending';
	} else if (validated === DOCUMENT_DELIVERY_STATUS.VALIDATED) {
		value = 'validated';
	}

	return value;
};
